export default "__VITE_ASSET__DVrPcL6a__"